import { ApiClient } from "./ApiClient";
import { RealmLower } from "../constants";

export type KeyMasterAction = "ENCRYPT" | "DECRYPT";

const ACTION_TO_OPERATION: Record<KeyMasterAction, string> = {
  ENCRYPT: "ENCODE",
  DECRYPT: "DECODE",
};

export class KeyMasterService {
  private api: ApiClient;

  constructor(api: ApiClient = ApiClient.getInstance()) {
    this.api = api;
  }

  async convert(stringToConvert: string, dataType: string, action: KeyMasterAction, realm: RealmLower): Promise<string> {
    const base = this.api.getBaseUrl("keymaster", realm);
    const region = this.api.getRegionCode(realm);
    const response = await this.api.post<{ result: string }>(`${base}/keymaster?region=${region}`, {
      data: stringToConvert,
      dataType,
      operation: ACTION_TO_OPERATION[action],
    });
    return response.result;
  }
}
